import {Route} from 'react-router-dom';
import NewsReorderView from './entities/news/ReorderView/index';
import ProgramReorderView from './entities/program/ReorderView/index';

export default [
    <Route path="/news/reorder" component={NewsReorderView}/>,
    <Route path="/program/reorder" component={ProgramReorderView}/>
];
